import * as React from "react";
import { Authenticator, Capability, WhenCapable } from "../../components/security";
import { Link, LinkProps } from "react-router-dom";
import { Redirect, Route } from "react-router";

// tslint:disable-next-line:variable-name
export default function PrivateLink({ capability, ...rest }: { capability?: Capability } & LinkProps)
{
    return (
        <WhenCapable capability={capability}>
            <Link {...rest} />
        </WhenCapable>
    );
}
